// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__YH1ta","wrapper":"intro_wrapper__LSLgP","sticky":"intro_sticky__I5mUJ"};